<div class="ui fluid container">
  <div *ngIf="screenImages.length === 1">
    <div *ngFor="let screenimg of screenImages; let imgIndex = index">
      <div class="screen-img-slider p-relative">
        <img class="ui fluid image" src="{{ screenimg.url }}" />
        <button
          class="ui icon primary large button"
          (click)="openDialog(imgIndex)"
        >
          <i class="expand icon"></i>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="screenImages.length > 1">
    <div class="swiper-container" [swiper]="swiperConfig">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          *ngFor="let screenimg of screenImages; let imgIndex = index"
        >
          <div class="screen-img-slider p-relative">
            <img class="ui fluid image" src="{{ screenimg.url }}" />
            <button
              class="ui icon primary large button"
              (click)="openDialog(imgIndex)"
            >
              <i class="expand icon"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev screen-banner-prev"></div>
      <div class="swiper-button-next screen-banner-next"></div>
    </div>
  </div>
</div>
